const brokerSteps = (index, existingBroker, publicBroker = false) => {
  const publicBrokerCompanyFields = [
    {
      type: 'name',
      label: 'Primary Contact',
      name: 'data.attributes.users[0]',
      selectType: 'users',
      required: true,
    },
    {
      type: 'address',
      label: 'Full Registered Address',
      name: 'data.attributes.organisation.address',
      required: true,
    },
    {
      type: 'address',
      label: 'Full Trading Address',
      name: 'data.attributes.address',
      required: true,
    },

    {
      type: 'input',
      label: 'Telephone',
      name: 'data.attributes.phone_number',
      required: true,
    },
    {
      type: 'email',
      label: 'Email',
      name: 'data.attributes.users[0]email',
      required: true,
    },
    {
      type: 'website',
      label: 'Website',
      name: 'data.attributes.metadata.website',
      required: true,
    },
    {
      type: 'select',
      label: 'Type of Company',
      name: 'data.relationships.legal_entity_type.data.id',
      selectType: 'entityTypes',
      source: 'public/legal-entity-types',
      required: true,
    },

    {
      type: 'date',
      label: 'Date Business Established',
      name: 'data.attributes.metadata.date_business_established',
      required: true,
    },
    {
      type: 'number',
      label: 'Number of Staff',
      name: 'data.attributes.metadata.number_of_staff',
      required: true,
      colSize: 2,
    },
    {
      type: 'input',
      label: 'FCA Authorisation Number',
      // name: 'data.attributes.organisation.regulatory_authority_number',
      name: 'data.attributes.organisation.legal_entity_number',
      required: true,
    },

    {
      type: 'input',
      label: 'Trading Phone Number',
      name: 'data.attributes.organisation.phone1',
      required: false,
    },
    {
      type: 'input',
      label: 'Company Registration Number',
      // name: 'data.attributes.organisation.legal_entity_number',
      name: 'data.attributes.metadata.company_registration_number',
      required: true,
    },

    {
      type: 'question',
      label: 'Do you have Call Recording?',
      name: 'data.attributes.metadata.has_call_recording',
      required: true,
      options: [
        {
          name: 'Yes',
          value: 'true',
        },
        {
          name: 'No',
          value: 'false',
        },
      ],
    },
  ];
  const newBrokerCompanyFields = [
    {
      type: 'name',
      label: 'Primary Contact',
      name: 'data.attributes.users[0]',
      selectType: 'users',
      //required: true,
    },
    {
      type: 'number',
      label: 'Contact Phone Number',
      name: 'data.attributes.phone_number',
      //required: true,
    },
    {
      type: 'select',
      label: 'Contact Role',
      name: 'data.attributes.users[0].role_id',
      selectType: 'role',
      //required: true,
    },
    {
      type: 'email',
      label: 'Email',
      name: 'data.attributes.users[0].email',
      //required: true,
    },

    {
      type: 'website',
      label: 'Website',
      name: 'data.attributes.metadata.website',
      //required: true,
    },

    {
      type: 'date',
      label: 'Date Business Established',
      name: 'data.attributes.metadata.date_business_established',
      //required: true,
    },
    {
      type: 'number',
      label: 'Number of Staff',
      name: 'data.attributes.metadata.number_of_staff',
      //required: true,
    },

    {
      type: 'question',
      label: 'Do you have Call Recording?',
      name: 'data.attributes.metadata.has_call_recording',
      //required: true,
      options: [
        {
          name: 'Yes',
          value: 'true',
        },
        {
          name: 'No',
          value: 'false',
        },
      ],
    },
  ];

  const existingBrokerCompanyFields = [
    {
      type: 'website',
      label: 'Website',
      name: 'data.attributes.metadata.website',
      //required: true,
    },

    {
      type: 'select',
      label: 'Classification of Firm',
      name: 'data.relationships.broker_category.data.id',
      selectType: 'brokerCategory',
      //required: true,
    },
    {
      type: 'date',
      label: 'Date Business Established',
      name: 'data.attributes.metadata.date_business_established',
      //required: true,
    },
    {
      type: 'number',
      label: 'Number of Staff',
      name: 'data.attributes.metadata.number_of_staff',
      //required: true,
    },

    {
      type: 'question',
      label: 'Do you have Call Recording?',
      name: 'data.attributes.metadata.has_call_recording',
      //required: true,
      options: [
        {
          name: 'Yes',
          value: 'true',
        },
        {
          name: 'No',
          value: 'false',
        },
      ],
    },
  ];

  const generalSteps = {
    title: 'General',
    key: 'generalInformation',
    route: '/business-form/general-information',
    introduction:
      'If you are applying to work with us as an Insurance Broker, please fill out our Online Application Form below.\n\nAlternatively, you can download the form and post it to us &mdash; click here to download form.',
    fields: [
      {
        type: 'input',
        label: 'Intermediary Name:',
        name: 'data.attributes.organisation.name',
        required: true,
      },
      {
        type: 'input',
        label: 'Trading Title:',
        name: 'data.attributes.trading_name',
        required: true,
      },
    ],
  };
  const companySteps = {
    title: 'Company',
    key: 'companyInformation',
    route: '/business-form/company-information',
    introduction: '# Agency - Company information',
    fields: publicBroker
      ? publicBrokerCompanyFields
      : existingBroker
      ? existingBrokerCompanyFields
      : newBrokerCompanyFields,
  };
  const accountSteps = {
    title: 'Account',
    key: 'accountInformation',
    route: '/business-form/account-information',
    introduction: '# Agency &ndash; Account information',
    fields: [
      {
        type: 'currency',
        label: 'Please state your annual Gross Written Premium (all business)',
        name: 'data.attributes.metadata.account.gwp_all',
        currency: 'GBP',
        colSize: 4,
        required: true,
      },
      {
        type: 'currency',
        label: 'Please state your annual Gross Written Premium for Travel Insurance',
        name: 'data.attributes.metadata.account.gwp_travel',
        currency: 'GBP',
        colSize: 4,
        required: true,
      },
      {
        type: 'free_type_percentage',
        label:
          'What is the percentage split between your personal lines and commercial lines business?',
        name: 'data.attributes.metadata.account.gwp_split',
        colSize: 3,
        required: true,
      },
      {
        type: 'question',
        label:
          'Does the firm hold “standard” agency terms and conditions with all Insurance providers?',
        name: 'data.attributes.metadata.account.hold_standards',
        moreInfoRequired: true,
        required: true,
        options: [
          {
            name: 'Yes',
            value: 'true',
          },
          {
            name: 'No',
            value: 'false',
          },
        ],
      },
      {
        type: 'question',
        label:
          'Do you have any special arrangements in place with an Insurer e.g. profit share, delegated underwriting authority, binding authority, enhanced commission? ',
        name: 'data.attributes.metadata.account.special_arrangements',
        moreInfoRequired: true,
        required: true,
        options: [
          {
            name: 'Yes',
            value: 'true',
          },
          {
            name: 'No',
            value: 'false',
          },
        ],
      },
      {
        type: 'question',
        label:
          'As the result of an audit, has any insurer restricted, suspended or withdrawn your authority (in the last five years)?',
        name: 'data.attributes.metadata.account.has_insurer_restrictions',
        moreInfoRequired: true,
        required: true,
        options: [
          {
            name: 'Yes',
            value: 'true',
          },
          {
            name: 'No',
            value: 'false',
          },
        ],
      },
      {
        type: 'question',
        label:
          'Do you operate any sub-broking facilities or make sales through Appointed Representatives (AR’s)?',
        name: 'data.attributes.metadata.account.has_sub_broking',
        moreInfoRequired: true,
        required: true,
        options: [
          {
            name: 'Yes',
            value: 'true',
          },
          {
            name: 'No',
            value: 'false',
          },
        ],
      },
    ],
  };
  const indemnitySteps = {
    title: 'Professional Indemnity',
    key: 'professionalIndemnity',
    route: '/business-form/professional-indemnity-cover',
    introduction: '# Agency &ndash; Professional Indemnity Cover Details',
    fields: [
      {
        type: 'input',
        label: 'Name of Insurer',
        name: 'data.attributes.metadata.insurer.name',
        required: true,
      },
      {
        type: 'input',
        label: 'Policy Number',
        name: 'data.attributes.metadata.insurer.policy_number',
        required: true,
      },
      {
        type: 'date',
        label: 'Expiry Date',
        name: 'data.attributes.metadata.insurer.expiry_date',
        required: true,
      },
      // {
      //   type: 'currency',
      //   label: 'Excess',
      //   name: 'data.attributes.metadata.insurer.excess',
      //   required: true,
      // },
      {
        type: 'currency',
        label: 'Indemnity Cover',
        name: 'data.attributes.metadata.insurer.indemnity_cover',
        required: true,
      },
      // {
      //   type: 'currency',
      //   label: 'Aggregate Limit',
      //   name: 'data.attributes.metadata.insurer.aggregate_limit',
      //   required: true,
      // },
      // {
      //   type: 'question',
      //   label: 'Does cover include dishonesty of the insured’s partners or directors?',
      //   name: 'data.attributes.metadata.insurer.include_partner_dishonesty',
      //   labelSize: 8,
      //   colSize: 4,
      //   moreInfoRequired: false,
      //   required: true,
      //   options: [
      //     {
      //       name: 'Yes',
      //       value: 'true',
      //     },
      //     {
      //       name: 'No',
      //       value: 'false',
      //     },
      //   ],
      // },
      // {
      //   type: 'question',
      //   label: 'Does cover include dishonesty of the insured’s staff? ',
      //   name: 'data.attributes.metadata.insurer.include_staff_dishonesty',
      //   labelSize: 8,
      //   colSize: 4,
      //   moreInfoRequired: false,
      //   required: true,
      //   options: [
      //     {
      //       name: 'Yes',
      //       value: 'true',
      //     },
      //     {
      //       name: 'No',
      //       value: 'false',
      //     },
      //   ],
      // },
      {
        type: 'question',
        label: 'Are there any circumstances known which may give rise to a claim?',
        name: 'data.attributes.metadata.insurer.claim_rise',
        moreInfoRequired: true,
        labelSize: 8,
        colSize: 4,
        required: true,
        options: [
          {
            name: 'Yes',
            value: 'true',
          },
          {
            name: 'No',
            value: 'false',
          },
        ],
      },
    ],
  };
  const managementSteps = {
    title: 'Management',
    key: 'managementInformation',
    route: '/business-form/management-information',
    introduction: '# Agency &ndash; Account information',
    fields: [
      {
        type: 'directorsArray',
        name: 'data.attributes.directors',
        required: true,
        fields: [
          {
            type: 'name',
            label: 'Names of Directors / Partners / Proprietor',
            name: 'name',
            //required: true,
          },
          {
            type: 'input',
            label: 'Position & Year of appointment',
            name: 'position_and_year',
            //required: false,
          },
          {
            type: 'input',
            label: 'FCA Individual Ref. Number',
            name: 'individual_fca_number',
            //required: false,
          },
          {
            type: 'question',
            label: 'Actively Involved',
            name: 'actively_involved',
            // required: true,
            options: [
              {
                name: 'Yes',
                value: 'true',
              },
              {
                name: 'No',
                value: 'false',
              },
            ],
          },
        ],
      },
    ],
  };
  const bankAccountsSteps = {
    title: 'Bank Accounts',
    key: 'bankAccountsSteps',
    route: '/business-form/bank_account',
    introduction: '# Agency &ndash; Account information',
    fields: [
      {
        type: 'name',
        label: 'Name of Contact for Accounts',
        name: 'data.attributes.metadata.bank_accounts.contact.name',
        // required: true,
      },
      {
        type: 'email',
        label: 'Email',
        name: 'data.attributes.metadata.bank_accounts.contact.email',
      },
      {
        type: 'input',
        label: 'Bankers Name and Address',
        name: 'data.attributes.metadata.bank_accounts.office.bankers_name_and_address',
      },
      {
        type: 'input',
        label: 'Sort Code',
        name: 'data.attributes.metadata.bank_accounts.office.sort_code',
      },
      {
        type: 'input',
        label: 'Account Number',
        name: 'data.attributes.metadata.bank_accounts.office.account_number',
      },
      {
        type: 'input',
        label: 'Client or Insurer Account Name',
        name: 'data.attributes.metadata.bank_accounts.client.account_name',
      },
      {
        type: 'input',
        label: 'Bankers Name and Address',
        name: 'data.attributes.metadata.bank_accounts.client.bankers_name_and_address',
      },
      {
        type: 'input',
        label: 'Sort Code',
        name: 'data.attributes.metadata.bank_accounts.client.sort_code',
      },
      {
        type: 'input',
        label: 'Account Number',
        name: 'data.attributes.metadata.bank_accounts.client.account_number',
      },
      {
        type: 'question',
        label:
          'Do you hold all money received from clients in accordance with the FCAs CASS rules?',
        name: 'data.attributes.metadata.bank_accounts.other_information.cass_rules',
        options: [
          {
            name: 'Yes',
            value: 'true',
          },
          {
            name: 'No',
            value: 'false',
          },
        ],
      },
      {
        type: 'select',
        label:
          'Please advise if your account is a Statutory Trust or Non-Statutory Trust account?',
        name: 'data.attributes.metadata.bank_accounts.other_information.statutory_trust',
      },
      {
        type: 'question',
        label: 'Please confirm that you have the necessary exchange of letters in place:',
        name:
          'data.attributes.metadata.bank_accounts.other_information.exchange_of_letters',
        options: [
          {
            name: 'Yes',
            value: 'true',
          },
          {
            name: 'No',
            value: 'false',
          },
        ],
      },
      {
        type: 'question',
        label:
          'If you have a non-statutory account, please confirm that you have the necessary trust deed in place:',
        name: 'data.attributes.metadata.bank_accounts.other_information.trust_deed',
        options: [
          {
            name: 'Yes',
            value: 'true',
          },
          {
            name: 'No',
            value: 'false',
          },
        ],
      },
    ],
  };
  const regulationSteps = {
    title: 'Regulation',
    key: 'regulationInformation',
    route: '/business-form/regulation-information',
    introduction: '# Agency &ndash; Management',
    fields: [
      {
        type: 'question',
        label: 'Are any directors or partners engaged in other business?',
        name: 'data.attributes.metadata.regulation.questions.other_business',
        required: true,
        options: [
          {
            name: 'Yes',
            value: 'true',
          },
          {
            name: 'No',
            value: 'false',
          },
        ],
      },
      {
        type: 'question',
        label:
          'Have you been convicted of a criminal offence or are there any prosecutions pending?',
        name: 'data.attributes.metadata.regulation.questions.prosecutions_pending',
        required: true,
        options: [
          {
            name: 'Yes',
            value: 'true',
          },
          {
            name: 'No',
            value: 'false',
          },
        ],
      },
      {
        type: 'question',
        label:
          'Are you subject to any adverse finding or settlement in civil proceedings?  This includes misconduct, fraud and management of a firm ',
        name: 'data.attributes.metadata.regulation.questions.civil_proceedings',
        required: true,
        options: [
          {
            name: 'Yes',
            value: 'true',
          },
          {
            name: 'No',
            value: 'false',
          },
        ],
      },
      {
        type: 'question',
        label:
          'Have you been interviewed in relation to any matters by FCA, other regulatory bodies, professional bodies, government bodies or agencies?',
        name: 'data.attributes.metadata.regulation.questions.fca_matters',
        required: true,
        options: [
          {
            name: 'Yes',
            value: 'true',
          },
          {
            name: 'No',
            value: 'false',
          },
        ],
      },
      {
        type: 'question',
        label:
          'Have you contravened any of the standards and or requirements of the regulator?',
        name: 'data.attributes.metadata.regulation.questions.contravened_standards',
        required: true,
        options: [
          {
            name: 'Yes',
            value: 'true',
          },
          {
            name: 'No',
            value: 'false',
          },
        ],
      },
      {
        type: 'question',
        label:
          'Are you the subject of any justified complaint which has been upheld, which relates to regulatory activities?',
        name: 'data.attributes.metadata.regulation.questions.justified_complaint',
        required: true,
        options: [
          {
            name: 'Yes',
            value: 'true',
          },
          {
            name: 'No',
            value: 'false',
          },
        ],
      },
      {
        type: 'question',
        label:
          'Have you been refused registration, authorisation, membership or licence to carry out a business or trade?',
        name: 'data.attributes.metadata.regulation.questions.refused_registration',
        required: true,
        options: [
          {
            name: 'Yes',
            value: 'true',
          },
          {
            name: 'No',
            value: 'false',
          },
        ],
      },
      {
        type: 'question',
        label:
          'Have you been involved in a relationship whereby any of the above have been removed, revoked or withdrawn?',
        name: 'data.attributes.metadata.regulation.questions.relationship_revoked',
        required: true,
        options: [
          {
            name: 'Yes',
            value: 'true',
          },
          {
            name: 'No',
            value: 'false',
          },
        ],
      },
      {
        type: 'question',
        label:
          'Have you, as a result of the above been refused the right to carry on a trade, business or profession requiring licence, authorisation or other?',
        name: 'data.attributes.metadata.regulation.questions.refused_trade',
        required: true,
        options: [
          {
            name: 'Yes',
            value: 'true',
          },
          {
            name: 'No',
            value: 'false',
          },
        ],
      },
      {
        type: 'question',
        label:
          'Have you been a Partner, Director, or member of a management team involved in a firm which has gone into insolvency, liquidation or administration?',
        name: 'data.attributes.metadata.regulation.questions.insolvency',
        required: true,
        options: [
          {
            name: 'Yes',
            value: 'true',
          },
          {
            name: 'No',
            value: 'false',
          },
        ],
      },
      {
        type: 'question',
        label:
          'Have you been investigated, disciplined, censured, suspended or criticised by a regulatory body, a court or tribunal, whether publicly or privately?',
        name:
          'data.attributes.metadata.regulation.questions.investigated_regulatory_body',
        required: true,
        options: [
          {
            name: 'Yes',
            value: 'true',
          },
          {
            name: 'No',
            value: 'false',
          },
        ],
      },
      {
        type: 'question',
        label:
          'Have you been dismissed or asked to resign from a position of trust, fiduciary appointment or similar?',
        name: 'data.attributes.metadata.regulation.questions.resigned',
        required: true,
        options: [
          {
            name: 'Yes',
            value: 'true',
          },
          {
            name: 'No',
            value: 'false',
          },
        ],
      },
      {
        type: 'question',
        label:
          'Have you ever been disqualified from acting as a Director or disqualified from acting in any managerial capacity?',
        name: 'data.attributes.metadata.regulation.questions.disqualified',
        required: true,
        options: [
          {
            name: 'Yes',
            value: 'true',
          },
          {
            name: 'No',
            value: 'false',
          },
        ],
      },
      {
        type: 'question',
        label:
          'Have you been subject to any judgment debt or award in the UK or elsewhere, that remains outstanding or was not satisfied within a reasonable timescale?',
        name: 'data.attributes.metadata.regulation.questions.judgement_debt',
        required: true,
        options: [
          {
            name: 'Yes',
            value: 'true',
          },
          {
            name: 'No',
            value: 'false',
          },
        ],
      },
      {
        type: 'question',
        label:
          'Whether in the UK or elsewhere, have you made any arrangements with creditors, filed for bankruptcy, had a bankruptcy petition served on you, been adjudged bankrupt, been the subject of bankruptcy restrictions, offered a bankruptcy restrictions undertaking, had assets sequestrated, or been involved in proceedings relating to any of these?',
        name: 'data.attributes.metadata.regulation.questions.bankruptcy',
        required: true,
        options: [
          {
            name: 'Yes',
            value: 'true',
          },
          {
            name: 'No',
            value: 'false',
          },
        ],
      },
      {
        type: 'input',
        label:
          'If you have answered Yes to any of the above questions please provide more information',
        name: 'data.attributes.metadata.regulation.questions.more_info',
      },
    ],
  };
  const declarationSteps = {
    title: 'Declaration',
    key: 'declaration',
    route: '/business-form/declaration',
    fields: [
      {
        type: 'question',
        label:
          'Have you been candid and truthful in all your dealings with any regulatory body and have you demonstrated a readiness and willingness to comply with the requirements and standards of the regulatory system and with other legal, regulatory and professional standards?',
        name: 'data.attributes.metadata.declaration.questions.truthful',
        required: true,
        options: [
          {
            name: 'Yes',
            value: 'true',
          },
          {
            name: 'No',
            value: 'false',
          },
        ],
      },
      {
        type: 'question',
        label:
          'Do you satisfy the competence and capability requirements in relation to the controlled functions you perform within the firm?',
        name: 'data.attributes.metadata.declaration.questions.competent',
        required: true,
        options: [
          {
            name: 'Yes',
            value: 'true',
          },
          {
            name: 'No',
            value: 'false',
          },
        ],
      },
      {
        type: 'question',
        label:
          'Are you able to demonstrate your experience and training in relation to your controlled functions?',
        name: 'data.attributes.metadata.declaration.questions.experience',
        required: true,
        options: [
          {
            name: 'Yes',
            value: 'true',
          },
          {
            name: 'No',
            value: 'false',
          },
        ],
      },
      {
        type: 'tickBox',
        label:
          'I confirm that all information contained within this agency application is correct to the best of my knowledge',
        name: 'data.attributes.metadata.declaration.broker_declaration',
        required: true,
      },
      {
        type: 'input',
        label: 'Position',
        name: 'data.attributes.metadata.declaration.position',
        required: true,
        labelSize: 2,
      },
      {
        type: 'date',
        label: 'Date',
        name: 'data.attributes.metadata.declaration.date',
        required: true,
        labelSize: 2,
      },
    ],
  };

  const brokerApplicationSteps = [
    generalSteps,
    companySteps,
    accountSteps,
    indemnitySteps,
    // managementSteps,
    bankAccountsSteps,
    regulationSteps,
    declarationSteps,
  ];

  const brokerSteps = [
    generalSteps,
    companySteps,
    accountSteps,
    indemnitySteps,
    // managementSteps,
    bankAccountsSteps,
    regulationSteps,
    declarationSteps,
  ];

  return existingBroker ? brokerSteps[index] : brokerApplicationSteps[index];
};

export default brokerSteps;
